module.exports = __webpack_public_path__ + "img/home-1-INTcgm@2x.536eeade.png";